import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';

export const softDeleteSurfaceNodesMutation = gql`
  mutation softDeleteSurfaceNodesMutation($ids: [ID!]!) {
    softDeleteSurfaceNodes(ids: $ids) {
      deletedSurfaceNode {
        ...surfaceNodeUnionId
      }
      references {
        ...surfaceNodeUnionId
      }
    }
  }
  ${surfaceUnionIdFragment}
`;

export default mutation(softDeleteSurfaceNodesMutation);
